// Stable, dependency-free hash of the analyzer-relevant pedigree structure,
// used purely to memoise recompute in the hook. Must be stable across runs for
// an unchanged pedigree (independent of object key order / array order).

function fnv1a(str) {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
  }
  return h.toString(16).padStart(8, '0');
}

// Canonicalise a member to only the fields that affect analysis, sorted so the
// hash is order-independent.
function canonicalMember(m) {
  const diagnoses = (m.diagnoses || [])
    .filter((d) => d && d.id)
    .map((d) => `${d.id}:${d.displayOnPedigree ? 1 : 0}`)
    .sort();
  const genotypes = (m.genotypes || [])
    .map((g) => `${(g.symbol || g.gene || '').trim()}:${g.carrierStatus || ''}`)
    .filter((s) => s !== ':')
    .sort();
  const phenotypes = (m.phenotypes || [])
    .filter((p) => p && p.id)
    .map((p) => `${p.id}:${p.observed === false ? 0 : 1}`)
    .sort();
  return [
    String(m.pid),
    m.gender || 'u',
    m.fatherId || '-',
    m.motherId || '-',
    (Array.isArray(m.spouseIds)
      ? [...m.spouseIds].map(String).sort()
      : []
    ).join(','),
    m.dod || m.dob || '',
    diagnoses.join('|'),
    genotypes.join('|'),
    phenotypes.join('|')
  ].join('~');
}

export function structureHash(members = []) {
  const canon = members
    .filter((m) => m && m.pid != null)
    .map(canonicalMember)
    .sort()
    .join('\n');
  return fnv1a(canon);
}
